import * as React from "react"
import CookieConsent from "react-cookie-consent";
import { StaticImage } from "gatsby-plugin-image"

const Header = () => {
	// Grab HTML Elements
    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(() => {
      const topo=document.querySelector('#topo')
      const menu=document.querySelector('#mobile-nav')
      
      if(isOpen) {
        topo.className='bg-white max-w-6xl mx-auto px-4 sm:px-6';
        menu.removeAttribute('hidden');
      }else{
        topo.className='max-w-6xl mx-auto px-4 sm:px-6';
        menu.setAttribute('hidden', true);
      }
    })
  
    return (
        <header className="absolute w-full z-30">
          <div className="max-w-6xl mx-auto px-4 sm:px-6" id="topo">
            <div className="flex items-center justify-between h-20 aos-init aos-animate" data-aos="fade-up">
                <div className="flex-shrink-0 mr-4">
                  <a className="flex flex-row" aria-label="Logo" href="/">
                    <StaticImage
                      src="../images/logo.png"
                      alt="Sistema wEstoque - PDV online, financeiro e fiscal"
                      placeholder="blurred"
                      layout="fixed"
                      quality={100}
                      className="h-11 fill-current"
                      width={185}
                    />
                    
                  </a>
                </div>
                <nav className="hidden md:flex md:flex-grow">
                    <ul className="flex flex-grow justify-end flex-wrap items-center text-lg">
                        <li><a className="text-gray-700 hover:text-westoque-400 font-semibold px-3 py-2 flex items-center hover:underline" href="/recursos">Recursos</a></li>
                        <li><a className="text-gray-700 hover:text-westoque-400 font-semibold px-3 py-2 flex items-center hover:underline" href="/precos">Planos & Preços</a></li>
                        <li><a className="text-gray-700 hover:text-westoque-400 font-semibold px-3 py-2 flex items-center hover:underline" href="https://www.westoque.com.br/blog/" rel="noreferrer" target="_blank">Blog</a></li>
                    </ul>
                    <ul className="flex flex-grow justify-end flex-wrap items-center text-lg">
                        <li><a className="font-medium text-westoque-400 hover:text-westoque-500 hover:underline border-indigo-600 px-3 py-3 mr-2 flex items-center" href="https://sistema.westoque.com.br" rel="noreferrer">Login</a></li>
                        <li><a className="font-medium w-full inline-flex items-center justify-center border border-transparent px-3 py-2 my-2 rounded-md text-white bg-westoque-400 hover:bg-gradient-to-r from-westoque-400 to-westoque-500 shadow-lg shadow-westoque-400/50 hover:transition-transform ease-in-out duration-1000 hover:scale-110 hover:underline " href="/usar">Use Grátis</a></li>
                    </ul>
                </nav>
                <div className="md:hidden mobile-menu">
                    <button className="hamburger-button false" aria-controls="mobile-nav" aria-expanded="false" onClick={() => setIsOpen(!isOpen)} >
                      <span className="sr-only">Menu</span>
                          { 
                          isOpen 
                          ? 
                          <svg className="w-6 h-6 fill-current text-gray-900 hover:text-gray-500" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
                          </svg>
                          :
                          <svg className="w-6 h-6 fill-current text-gray-900 hover:text-gray-500" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/>
                          </svg>
                          }
                      </button>
                    
               </div>
            </div>
          </div>
          <div id="mobile-nav" className="md:hidden absolute top-full z-20 left-0 overflow-hidden" style={{width: `100%`}} >
            <nav>
                <ul className="bg-white px-6 py-2">
                    <li><a className="flex text-gray-600 hover:text-westoque-400 py-2 text-lg font-bold" href="/recursos">Recursos</a></li>
                    <li><a className="flex text-gray-600 hover:text-westoque-400 py-2 text-lg font-bold" href="/precos">Planos & Preços</a></li>
                    <li><a className="flex text-gray-600 hover:text-westoque-400 py-2 text-lg font-bold" href="https://www.westoque.com.br/blog/" rel="noreferrer" target="_blank">Blog</a></li>
                    <li><a className="flex font-medium w-full text-westoque-400 hover:text-westoque-500 py-2 justify-center" href="https://sistema.westoque.com.br/" rel="noreferrer">Login</a></li>
                    <li><a className="font-medium w-full inline-flex items-center justify-center border border-transparent px-4 py-2 my-2 rounded-sm text-white bg-westoque-400 hover:bg-westoque-500 shadow-md shadow-westoque-400/50 transition duration-150 ease-in-out" href="/usar">Use Grátis</a></li>
                </ul>
            </nav>
          </div>
          <CookieConsent
            location="bottom"
            buttonText="OK 😋"
            cookieName="westoque-gdpr-google-analytics"
            acceptOnScroll={true}
            acceptOnScrollPercentage={10}
            style={{backgroundColor: "rgba(1000,1000,1000,0.95)", border: `2px solid #ccc`, left: ``, right: `0px`, }}
            buttonClasses="font-bold text-xl md:text-2xl"
          >
            <h1 className="font-bold text-md md:text-2xl text-black mb-2"><span className="text-3xl">🍪</span> Usamos cookies para melhorar a sua experiência.</h1>
          </CookieConsent>
      </header>
    )
}

export default Header